var Tags;
(function (Tags) {
    var Controller = (function () {
        var _data = [];

        function Controller() {
            var _this = this;
        }

        Controller.prototype.loadData = function (guid, callback) {
            if (_data === null || _data.length === 0) {
                $.getJSON('/api/golfbox/GetTagsByBusinessUnit/' + guid)
                .done(function (data) {
                    if (data != null && data.length > 0) {
                        _data = data;
                        _data.sort(function (a, b) {
                            return a.localeCompare(b);
                        });
                    }
                    
                    $.isFunction(callback) && callback();
                });
            } else {
                callback();
            }
        }
        Controller.loadData = Controller.prototype.loadData;

        Controller.prototype.updateAutocomplete = function (propertyName, scope, id) {
            $(document).off('input', '#' + scope + ' input').on('input', '#' + scope + ' input', function () {
                if (this.value.length > 1) {
                    Controller.updateAutocomplete(propertyName, scope, this.id);
                }
            }).off('click', '#' + scope + ' #addTag').on('click', '#' + scope + ' #addTag', function () {
                var tagValue = $(this).next().val();
                if (tagValue !== "") {
                    Controller.BuildTags(propertyName, tagValue);
                    $(this).next().val("");
                }
            }).off('click', '#' + scope + ' #tagQuestion').on('click', '#' + scope + ' #tagQuestion', function () {
                var element = $('#tag-message-attention');
                var parent = $('#tagQuestion');
                if (element.hasClass('active')) {
                    element.removeClass('active');
                    element.addClass('inactive');
                    parent.removeClass('active');
                    parent.addClass('inactive');
                } else {
                    element.removeClass('inactive');
                    element.addClass('active');
                    parent.removeClass('inactive');
                    parent.addClass('active');
                }
            }).off('click', '#' + scope + ' #tag-exit-attention').on('click', '#' + scope + ' #tag-exit-attention', function () {
                var element = $('#tag-message-attention');
                element.removeClass('active');
                element.addClass('inactive');
                var parent = $('#tagQuestion');
                parent.removeClass('active');
                parent.addClass('inactive');
            }).off('click', '.tagButton').on('click', '.tagButton', function (e) {
                if ($(e.target).hasClass('icon-mini_remove')) {
                    var element = e.target.parentElement;
                    element.remove();
                }
            });

            $('#' + scope + ' input.tag[type="text"]').on('blur', function () {
                if (!$(this).next().hasClass('active')) {
                    $('#' + scope + ' #addTag').click();
                }
            }).on('keydown', function (e) {
                if (e.keyCode === 13) {
                    var self = this;
                    setTimeout(function () { self.focus(); }, 100);
                }
            });

            var resultText = function (text, regex) {
                var arr = text.split(regex);
                var match = text.match(regex);

                if (regex.test(text)) {
                    return resultText(arr[0], regex) + '<b>' + match[0] + '</b>' + resultText(arr[1], regex);
                } else {
                    return text;
                }
            };

            var selector = id || scope + ' input[type="text"]';
            $('#' + selector).each(function () {
                var resultsid = 'autocompleteResults_' + this.id;
                var obj = $('#' + resultsid);
                var _that = this;
                obj.empty();

                var html = '';
                var array = gb.util.array.search(this.value, null, _data, true, false, true);

                if (this.value.length > 0) {
                    var regex = new RegExp(this.value, "i");
                    for (var i = 0; i < array.length; i++) {
                        var tag = array[i];
                        html += '<div class="autocompleteResult" data-name="' + tag + '">' + resultText(tag, regex) + '</div>';
                    }
                }

                obj.html(html);
                obj.children().on('mousedown', function (e) {
                    var _self = $(this);
                    $(_that).val(_self.data('name'));

                    setTimeout(function () {
                        Controller.updateAutocomplete(propertyName, scope, _that.id);
                    }, 500);
                });
            });
        }
        Controller.updateAutocomplete = Controller.prototype.updateAutocomplete;

        Controller.prototype.BuildTags = function (propertyName, name) {
            var tag = $('input[name="' + propertyName + '"][value="' + name + '"]');
            if (tag.length === 0) {
                name = name.toLowerCase();
                var _this = this;
                var html = $.parseHTML('<div class="button genericButton tagButton newTag destroyable">' +
                    '<div class="buttonIconRight icon10White icon-mini_remove"></div>' +
                    '<div class="seperatorLightGreyVertical"></div>' +
                    '<div class="seperatorDarkGreyVertical"></div>' +
                    '<div class="buttonText">' + name + '</div>' +
                    '<input type="hidden" name="' + propertyName + '" value="' + name + '" />' +
                    '</div>');
                var parent = $('.tagsContainer');

                var elm = $(html).appendTo(parent);
                setTimeout(function () {
                    elm.removeClass('newTag');
                }, 1);
            } else {
                tag.parent().addClass('newTag');
                setTimeout(function () {
                    tag.parent().removeClass('newTag');
                }, 300);
            }
        }
        Controller.BuildTags = Controller.prototype.BuildTags;

        return Controller;
    })();
    Tags.Controller = Controller;
})(Tags || (Tags = {}));
var tagsController = new Tags.Controller();